import React from 'react';
import styled from 'styled-components';
import { Input, CurrencyInput } from '../../common';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Label = styled.span`
  font-size: 10px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.textBold};
  ${(props) =>
    props.error &&
    `
        color: ${props.theme.colors.error}
    `}
`;

const StyledInput = styled(Input)`
  height: 26px;
  background-color: transparent;
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid ${(props) => props.theme.colors.darkGrey};
  ${(props) =>
    props.error &&
    `
        border-color: ${props.theme.colors.error}
    `}
`;

export const TextInputWithLabel = ({ label, error, isCurrency, ...rest }) => (
  <Wrapper>
    <Label error={error}>{label}</Label>
    {isCurrency ? (
      <CurrencyInput
        error={error}
        variant={'hollow'}
        {...rest}
      />
    ) : (
      <StyledInput
        error={error}
        {...rest}
      />
    )}
  </Wrapper>
);
